// City Kit — Blender-generated low-poly buildings (scripts/gen-city-kit.py).
//
// These are modelled GLBs, not primitive prefabs: windows are genuinely
// recessed, silhouettes bevelled, roofs carry mechanical clutter. That buys
// quality at the cost of per-piece editability, which is the right trade for
// hero architecture you walk past. For interiors you decorate, use PREFABS.
//
// Real-world metres (a storey is 3.3m), origin at the ground-plane centre,
// front facing +Z. Placed with autoFit off so they land at true scale, and
// collidable so avatars can't walk through them.

export interface CityBuilding {
  id: string;          // file stem, e.g. modern_glass_tower_1
  kind: string;        // archetype key
  label: string;
  variation: number;
}

export interface CityFlavor {
  id: string;
  title: string;
  blurb: string;
  buildings: CityBuilding[];
}

const LABELS: Record<string, string> = {
  glass_tower: 'Glass Tower',
  office_tower: 'Office Tower',
  corporate_block: 'Corporate Block',
  residential: 'Residential',
  lowrise: 'Low-Rise',
  walkup: 'Walk-Up',
  warehouse: 'Warehouse',
  corner_shop: 'Corner Shop',
  tenement: 'Tenement',
  spire: 'Spire',
  arcology: 'Arcology',
  hab: 'Hab Block',
  hub: 'Transit Hub',
};

const KINDS: Record<string, string[]> = {
  modern: ['glass_tower', 'office_tower', 'corporate_block', 'residential', 'lowrise'],
  brick: ['walkup', 'tenement', 'warehouse', 'corner_shop'],
  scifi: ['spire', 'arcology', 'hab', 'hub'],
};

const VARIATIONS = 3;

const build = (flavor: string): CityBuilding[] =>
  KINDS[flavor].flatMap((kind) =>
    Array.from({ length: VARIATIONS }, (_, i) => ({
      id: `${flavor}_${kind}_${i + 1}`,
      kind,
      label: LABELS[kind],
      variation: i + 1,
    }))
  );

export const CITY_FLAVORS: CityFlavor[] = [
  { id: 'modern', title: 'Modern Downtown', blurb: 'Glass, concrete and setback crowns', buildings: build('modern') },
  { id: 'brick', title: 'Brick & Neon', blurb: 'Fire escapes, water towers, neon signs', buildings: build('brick') },
  { id: 'scifi', title: 'Sci-Fi', blurb: 'Glow bands, cantilevers, landing rings', buildings: build('scifi') },
];

export const cityGlbUrl = (id: string) => `/props/city/${id}.glb?v=9`;
export const cityThumbUrl = (id: string) => `/props/city/thumbs/${id}.jpg`;
